<template>
  <!-- 基本信息 -->
  <div class="w-full h-full ">
    <el-card class="h-full" v-loading="flowLoading">
      <div class="h-full flex flex-col">
        <div class="flex justify-between items-center">
          <span
            v-if="['update', 'create', 'approve'].includes(editType)"
            class="border-l-3 border-color-primary pl-10px text-18px"
            >{{ editType === 'read' ? '详情' : '审批' }}</span
          >
          <div v-else>
            <el-page-header content="详情" @back="$emit('back')"> </el-page-header>
          </div>
          <el-button v-if="$hasAccess('flow') && flowTaskId" @click="viewProcess"
            >查看流程</el-button
          >
        </div>
        <div class="flex-1 overflow-y-auto mt-20px h-0">
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="0">
              <BaseInfo @back="$emit('back')" ref="baseInfo" />
            </el-tab-pane>
            <el-tab-pane label="培训记录" name="1">
              <train-manage-record-list v-if="activeName == '1'" :userId="accountId" />
            </el-tab-pane>
            <el-tab-pane label="考试记录" name="2">
              <exam-manage-record-study
                v-if="activeName == '2'"
                :userId="accountId"
              ></exam-manage-record-study>
            </el-tab-pane>
            <el-tab-pane label="违章信息" name="3">
              <anti-violation-management-file-info
                v-if="activeName == '3'"
                :userId="accountId"
                :unitId="orgId"
                @showviolationDialog="showviolationDialog"
              ></anti-violation-management-file-info>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="flex justify-center mt-20px" v-if="editType !== 'read'">
          <el-button type="primary" size="small" @click="openApproveDailog">审批</el-button>
          <el-button size="small" class="iconfont icon-close" @click="$emit('back')"
            >取消</el-button
          >
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="违章信息详情"
        :visible.sync="showViolation"
        width="90%"
        class="large-dialog pr-10px"
        v-dialogDrag
      >
        <!-- <el-button @click="viewProcess" plain class="flot-right" v-if="'vioExamine' !== pageName"
          >查看流程</el-button
        > -->
        <BasicInfoCom
          :propsKey="propsKey"
          :operateType="['vioExamine'].includes(pageName) ? 'create' : 'action'"
          ref="BasicInfoCom"
        />
        <MainCom :operateFormat="operateFormat" ref="MainInfoCom" :propsStatus="6" />
        <!-- 延期 -->
        <!-- <DelayReq :visible.sync="delayVis" v-if="delayVis" :delayData="originData" /> -->
      </el-dialog>
      <!-- 审批弹窗 -->
      <el-dialog
        v-if="visible"
        :close-on-click-modal="false"
        title="审批"
        :visible.sync="visible"
        class="small-dialog"
        v-dialogDrag
        append-to-body
      >
        <el-form ref="checkResultForm" label-width="150px" :model="checkResultForm">
          <el-form-item
            label="审批结果"
            prop="isPass"
            :rules="[{ required: true, message: '请选择审批结果', trigger: 'blur' }]"
          >
            <el-radio-group v-model="checkResultForm.isPass">
              <el-radio :label="true">审批通过</el-radio>
              <el-radio :label="false">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="审批意见"
            prop="approve"
            :rules="[{ required: true, message: '请输入审批意见', trigger: 'blur' }]"
            v-if="!checkResultForm.isPass"
          >
            <el-input
              v-model="checkResultForm.approve"
              type="textarea"
              :rows="4"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex justify-center">
          <el-button size="small" type="primary" @click="handleSaveResult" :loading="cardLoading"
            >保存</el-button
          >
          <el-button size="small" @click="cancelResult">取消</el-button>
        </div>
      </el-dialog>

      <!-- 流程弹窗 -->
      <ApprovalFlowDialog
        :visible.sync="approvalFlowDialog"
        v-if="approvalFlowDialog"
        :id="flowTaskId"
        @cancel="approvalFlowDialog = false"
      >
      </ApprovalFlowDialog>

      <!-- 选择人员弹窗start -->
      <SelectDeptUser
        v-if="showUserDialog"
        :visible.sync="showUserDialog"
        :flowName="flowName"
        :flowWorkName="'承包商人员退厂审批'"
        nodeName="结束节点"
        @selectSuccess="selectSuccess"
      ></SelectDeptUser>
      <!-- 选择人员弹窗end -->
    </el-card>
  </div>
</template>

<script>
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import TrainManageRecordList from '@/modules/educational-training-management-sm/views/trainManage/RecordList.vue'
import ExamManageRecordStudy from '@/modules/educational-training-management-sm/views/examManage/RecordStudy.vue'
import BasicInfoCom from '@/components/safety/WizSafetyPage/violation/BasicInfoCom.vue'
import MainCom from '@/components/safety/WizSafetyPage/violation/MainCom.vue'
import AntiViolationManagementFileInfo from '@/components/safety/WizSafetyPage/violation/FileInfo.vue'
import { sourceList } from '@/components/safety/WizSafetyPage/violation/enums'
import { ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import { find } from 'lodash'
import BaseInfo from './BaseInfo'
import SelectDeptUser from './SelectDeptUser'
import DiyService from '../services/DiyService'

const contractorPersonnelApi = new ContractorPersonnelApi()
const violationRecordApi = new ViolationRecordApi()
export default {
  name: 'personnel-leave-detail',
  props: {
    pageType: {
      type: String,
      default: 'create',
    },
    taskId: {
      type: String,
      default: '',
    },
    rowId: {
      type: String,
      default: '',
    },
    flowTaskId: {
      type: [String, Number],
      default: null,
    },
    accountId: {
      type: String,
      default: '',
    },
    orgId: {
      type: String,
      default: '',
    },
    isSelectUser: {
      type: Boolean,
      default: false,
    }, // 是否有人员选择功能
    flowName: {
      type: String,
      default: '',
    }, // 流程名称
  },
  components: {
    BaseInfo,
    ApprovalFlowDialog,
    TrainManageRecordList,
    ExamManageRecordStudy,
    BasicInfoCom,
    MainCom,
    AntiViolationManagementFileInfo,
    SelectDeptUser,
  },
  data() {
    return {
      cardLoading: false,
      showUserDialog: false, // 是否显示人员选择弹窗
      approvalFlowDialog: false,
      // 审批弹窗
      visible: false,
      checkResultForm: {
        isPass: true,
        approve: '',
      },
      editType: 'read',
      activeName: '0',
      showViolation: false,
      pageName: '',
      operateFormat: {},
      propsKey: '',
      flowHistoryList: [], // 已审批流程数据
      flowLoading: false, // 获取流程loading
      useSelectUser: false, // 是否启用人员选择功能
      flowStepsList: [], // 流程步骤
    }
  },
  created() {
    this.useSelectUser = this.isSelectUser
    if (this.$route.query?.isSelectUser === 'true') {
      this.useSelectUser = true
    }
  },
  methods: {
    /**
     * @description 获取已审批流程数据
     * @param {String} flowId 流程id
     */
    async getFlowList(flowId) {
      if (!flowId) return
      const [err, res] = await DiyService.getFlowHistoryList({
        FlowId: flowId,
      })
      if (!err && res?.Code === 1 && res?.Data) {
        this.flowHistoryList = res.Data
      }
    },

    /**
     * @description 获取流程步骤
     */
    async getFlowStepsList() {
      if (!this.flowHistoryList?.length) return
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.flowHistoryList[0].FlowDesignId },
      })
      if (!err && res?.Code === 1 && res?.Data) {
        this.flowStepsList = res.Data
      }
    },

    viewProcess() {
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
        return
      }
      this.approvalFlowDialog = true
    },
    // 获取详情
    async getDetail(id) {
      const [err, res] = await violationRecordApi.getRecord({ id })
      if (err && !res) return
      this.$refs.BasicInfoCom?.detailShow(res.violationRecord)
      this.$refs.MainInfoCom?.detailShow(res.violationHandling)
      this.originData = res
      // this.reqCount = this.reqCount + 1
    },
    showviolationDialog(params) {
      this.getDetail(params.id)
      this.showViolation = true
      this.propsKey = sourceList[params.operateType].base
      this.pageName = params.operateType
      this.operateFormat = sourceList[params.operateType]
    },
    // 打开审批
    openApproveDailog() {
      this.checkResultForm = this.$options.data().checkResultForm
      this.visible = true
    },
    // 取消审批
    cancelResult() {
      this.visible = false
    },
    // 审批
    handleSaveResult() {
      this.$refs.checkResultForm.validate(async (valid) => {
        if (valid) {
          const currentFlowNode = find(this.flowStepsList, (step) => {
            return this.flowHistoryList[0]?.ToNodeName === step.NodeName
          })
          if (
            this.useSelectUser &&
            currentFlowNode &&
            currentFlowNode.NodeType !== 'End' &&
            this.checkResultForm.isPass
          ) {
            this.showUserDialog = true
            return
          }
          this.cardLoading = true
          const [err, res] = await contractorPersonnelApi.exitApprove({
            body: {
              id: this.rowId,
              taskId: this.taskId,
              ...this.checkResultForm,
            },
          })
          this.cardLoading = false
          if (!err) {
            this.$message({
              showClose: true,
              message: '审批成功',
              type: 'success',
            })
            this.visible = false
            this.$emit('save')
          }
        }
      })
    },

    /**
     * @description 选择人员完成
     * @param {Array} userIds 人员id
     */
    async selectSuccess(userIds) {
      this.cardLoading = true
      const [err, res] = await contractorPersonnelApi.exitApprove({
        body: {
          id: this.rowId,
          taskId: this.taskId,
          ...this.checkResultForm,
          receiverIds: userIds,
        },
      })
      this.cardLoading = false
      if (!err) {
        this.$message({
          showClose: true,
          message: '审批成功',
          type: 'success',
        })
        this.visible = false
        this.$emit('save')
      }
    },

    async handleDetail(row, editType) {
      if (editType) {
        this.editType = editType
      }
      this.$refs.baseInfo.handleDetail(row)
      await this.getFlowList(row.exitFlowTaskId)
      this.getFlowStepsList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs {
  height: 100%;
  .el-tabs__content {
    height: calc(100% - 55px);
    .el-tab-pane {
      height: 100%;
      overflow-y: auto;
    }
  }
}
</style>
